import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Container, Box, CircularProgress } from '@mui/material';
import { useAuth } from './context/AuthContext';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingAlert from './components/FloatingAlert';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Landing from './pages/Landing';
import Chat from './pages/Chat';
import TermsOfUse from './pages/TermsOfUse';
import DocumentsCollections from './pages/DocumentsCollections';
import DocumentsDashboard from './pages/DocumentsDashboard';

// Component to protect routes
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // If still loading, show a loading indicator rather than redirecting
  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '200px' 
      }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // Only redirect when we're sure the user is not authenticated
  if (!isAuthenticated) {
    console.log("Protected route: User not authenticated, redirecting to login");
    return <Navigate to="/login" />;
  }
  
  return children;
};

function App() {
  return (
    <Box sx={{
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh'
    }}>
      {/* Floating development warning alert */}
      <FloatingAlert 
        severity="info"
        title="Pagina en desarrollo"
        message="Nos encontramos en Beta cerrada. Si tienes alguna duda, por favor contacta a nuestro soporte."
        initialShow={true}
      />

      <Header />
      <Box component="main" >
        <Routes>
          {/* Landing page route */}
          <Route path="/" element={<Landing />} />
          
          {/* Other routes with Container */}
          <Route path="/login" element={
            <Container className="main-container">
              <Login />
            </Container>
          } />
          
          <Route path="/register" element={
            <Container className="main-container">
              <Register />
            </Container>
          } />
          
          <Route path="/profile" element={
            <Container className="main-container">
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            </Container>
          } />
          
          <Route path="/chat" element={
            <Chat />
          } />
          
          <Route path="/terms" element={
            <Container className="main-container">
              <TermsOfUse />
            </Container>
          } />
        
          <Route path="/docs" element={
              <DocumentsCollections />
          } />
          
          <Route path="/dashboard" element={
              <DocumentsDashboard />
          } />
        </Routes>
      </Box>
      
      <Footer />
    </Box>
  );
}

export default App;